<template>
  <div>
    <b-check-box
      :class="{'b-toggleable-content--read-only': readOnly  }"
      :label="label"
      v-model="internalValue"
      :disabled="readOnly"
      :uuid="uuid"
      :propPath="propPath"
      hide-details
    ></b-check-box>
    <slot v-if="internalValue" name="content"></slot>
  </div>
</template>

<script>
export default {
  model: {
    event: 'change'
  },
  props: {
    value: null,
    label: String,
    readOnly: Boolean,
    uuid: String,
    propPath: String,
  },
  data() {
    return {
      lazyValue: this.value
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.lazyValue;
      },
      set(val) {
        if (val != this.lazyValue) {
          this.lazyValue = val;
          this.$emit('change', val);
        }
      }
    }
  },
  watch: {
    value(val) {
      this.lazyValue = val;
    }
  }
};
</script>

<style lang="scss">
</style>
